import initializeMobileMenu from './menu';
import initializeCollapse from './blocks/collapse';
import initializeFiles from './blocks/files';
import initializeIconBoxes from './blocks/icon-boxes';
import initializeNumbersBlock from './blocks/numbers';
import initializeFancyBox from './fancybox';
import initializeGallerySection from './blocks/gallery-section';
import initializeGalleryGrid from "./blocks/gallery-grid";
import initializeForm from './utils/form';
import initializeBrands from './blocks/brands';
import initializeGallerySlider from './blocks/gallery-slider';
import initializeGalleryText from './blocks/gallery-text';
import initializeIconBoxesAnimation from './blocks/icon-boxes-animation';
import initializeSearch from './blocks/search';
import './utils/scrollup';
import './blocks/paralax_new';
import initializeProduct from './utils/product';
import blockImageSlider from './blocks/image-slider';
import initializeProductSlider from './blocks/products_recommended';
// import WooCommerce from './woo'

class App {
    constructor() {
        this.initialize();
    }

    initialize() {
        import('aos/dist/aos.js').then(({ default: AOS }) => {
            AOS.init({
                startEvent: 'load',
                disable: 'mobile',
                once: true,
                duration: 500
            });
        });
        initializeForm();
        initializeFancyBox();
        initializeMobileMenu();
        initializeCollapse();
        initializeFiles();
        initializeIconBoxes();
        initializeNumbersBlock();
        initializeGallerySection();
        initializeGalleryGrid();
        initializeBrands();
        initializeGallerySlider();
        initializeGalleryText();
        initializeIconBoxesAnimation();
        initializeSearch();
        blockImageSlider();
        initializeProductSlider();
        initializeProduct();
        // const Woo = new WooCommerce();
    }
}

function initializeApp() {
    const app = new App();


    // if (window.location.hash === "#buy") {
    //     // Знаходимо другий елемент з класом block-collapse__accordion__item
    //     const blockAccordion = document.querySelector(".block-collapse__accordion");
    //     const secondAccordionItem = blockAccordion?.querySelectorAll(".block-collapse__accordion__item")[1]; // другий елемент
    //
    //     if (secondAccordionItem) {
    //         // Розгортаємо другий елемент, додаючи йому клас "active"
    //         secondAccordionItem.classList.add("active");
    //
    //         // Перевірка іконки для візуального розгортання
    //         const icon = secondAccordionItem.querySelector(".block-collapse__accordion__header__icon");
    //         if (icon) {
    //             icon.classList.add("expanded"); // або інші стилі для відкритої іконки
    //         }
    //
    //         // Обчислюємо позицію з урахуванням додаткового зсуву 100 пікселів
    //         const elementPosition = secondAccordionItem.getBoundingClientRect().top + window.pageYOffset - 160;
    //
    //         // Прокручуємо сторінку до обчисленої позиції
    //         window.scrollTo({ top: elementPosition, behavior: "smooth" });
    //     }
    // }
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeApp);
} else {
    initializeApp();
}


window.addEventListener('scroll', function() {
    var fix_header = document.querySelector('.header');
    var scrollPosition = window.scrollY;


    if (scrollPosition > 10) {
        fix_header.classList.add('header_fixed');
    } else {
        fix_header.classList.remove('header_fixed');
    }
});


